

































import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";
@Component({
})
export default class Edit extends Vue {
  @Provide() private nationValue: string = "";
  @Provide() private options: any = [{ value: "stuff", label: "stuff" }];
  @Provide() private token: string | null = "";
  @Provide() private rules: any = {
    email: [
      { required: true, message: "请输入", trigger: "blur" },
      { min: 1, max: 29, message: "长度小于30个字符", trigger: "blur" }
    ],
    role: [{ required: true, message: "请输入", trigger: "blur" }],
    check: [{ required: true, message: "请输入", trigger: "blur" }],
    password: [{ required: true, message: "请输入", trigger: "blur" }],
    employeeId: [{ max: 14, message: "长度小于15个字符", trigger: "blur" }],
  };
  @Provide() private buttonsData: any = {
      value: 111,
      name: "",
      remarks: ""
  };

  private created() {
    this.token = localStorage.getItem("token");
  }

  private submitForm(formName: string) {
    const ref: any = this.$refs[formName];
    ref.validate((valid: boolean) => {
      if (valid) {
        this.commitUserMessage();
      } else {
        return false;
      }
    });
  }

  private commitUserMessage() {
  }

  private resetForm(formName: string) {
    const ref: any = this.$refs[formName];
    ref.resetFields();
    this.closeAddDialog();
  }

  private closeAddDialog() {
    
  }
}
